import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';
// External components
import Datepicker from 'vuejs-datepicker';
// Services
import CandidateService from '@/core/services/candidate.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    LoaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    Datepicker
  }
})
export default class EvaluatedInactiveComponent extends Vue {

  // Service's Instance
  candidateService: any = new CandidateService();
  sidebarService: any = new SidebarService();
  isLoading: boolean = false;
  modal: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  deleteIcon: boolean = false;
  nextPositionDisabled: boolean = false;
  previousPositionDisabled: boolean = true;
  pagination: boolean = true;
  userToActivar: any;
  searchFlag: any = [];
  candidateList: any = [];
  filterCandidateList: any = [];
  companyList: any = [];
  name: string = "";
  search: string = "";
  finderCompanies: any = "default";
  searchByDate: any = "";
  deletedAt: string = "";
  filterConcatDate: string = "";
  companyToSearch: string = "";
  pageOffset: number = 0;
  itemsPerPage: number = 50;
  totalPages: number;
  currentPage: number = 1;
  nextPage: number = 2;
  totalOfEvaluated: number = 0;
  itemsOfFrom: number = 0;
  itemsOfTo: number = 0;

  mounted (){
    const _ = this;
    _.getCompanies();
    _.getInactive(_.pageOffset, _.itemsPerPage);
    _.filterDate();
  }

  filterByDate(){
    const _ = this;
    _.deleteIcon = true;
    console.log(_.searchByDate)
    let day = _.searchByDate.getDate() < 10 ? '0' + _.searchByDate.getDate() : _.searchByDate.getDate();
    let month = _.searchByDate.getMonth() < 10 ? '0' + (_.searchByDate.getMonth() + 1) : _.searchByDate.getMonth() + 1;
    let year = _.searchByDate.getFullYear();
    _.filterConcatDate = `${year}-${month}-${day}`;
    if(_.finderCompanies == 'default'){
      console.log('Es default');
      _.filterCandidateList = _.candidateList.filter((candidate) => {
        let parseDate: any = candidate.deletedAt.split('T');
        parseDate = parseDate[0];
        return _.filterConcatDate == parseDate;
      })
      return;
    }
    _.filterCandidateList = _.candidateList.filter((candidate) => {
      let parseDate: any = candidate.deletedAt.split('T');
      parseDate = parseDate[0];
      return candidate.company.name == _.finderCompanies && _.filterConcatDate == parseDate;
    })

    console.log(_.finderCompanies, ' Finder companies');
    console.log(_.filterConcatDate);
  }

  deleteDate(){
    const _ = this;
    _.filterConcatDate = '';
    _.deleteIcon = false;
    if(_.filterConcatDate == ''){
      _.searchByDate = '';
      _.filterCandidateList = _.candidateList;
      return;
    }
  }

  fiterByCompany(company){
    const _ = this;
    if(company == 'default' && _.filterConcatDate == ''){
      _.filterCandidateList = _.candidateList;
      return;
    }

    if(company == 'default' && _.filterConcatDate != ''){
      _.filterCandidateList = _.candidateList.filter((candidate) => {
        let parseDate: any = candidate.deletedAt.split('T');
        parseDate = parseDate[0];
        return _.filterConcatDate == parseDate;
      })
      return;
    }

    if(_.filterConcatDate != ''){
      _.filterCandidateList = _.candidateList.filter((candidate) => {
        let parseDate: any = candidate.deletedAt.split('T');
        parseDate = parseDate[0];
        console.log(_.filterConcatDate, ' Created');
        console.log(parseDate, ' Parse')
        return candidate.company.name == company && _.filterConcatDate == parseDate;
      })
      return;
    }
    _.filterCandidateList = _.candidateList.filter((candidate) => {
      return candidate.company.name == company;
    })
  }

  filterDate(date: any = ''){
    const _ = this;
    date = date.split("T");
    date = date[0];
    return date;
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  openModal(id){
    const _ = this;
    _.userToActivar = id;
    _.modal = true;
  }

  getCompanies(){
    const _ = this;
    _.isLoading = true;
    _.candidateService.getCompanies().then((data: any) => {
      _.companyList = data['data'].companies;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      _.isLoading = false;
    })
  }

  getInactive(pageOffset = 0, itemsPerPage = 50){
    const _ = this;
    console.log(pageOffset, itemsPerPage);
    _.isLoading = true;
    _.candidateService.getInactive(pageOffset, itemsPerPage).then((data: any) => {
      console.log(data);
      _.candidateList = data['data'].users;
      _.filterCandidateList = data['data'].users;
      console.log(data);
      _.totalOfEvaluated = data['data'].total;
      _.totalPages = Math.ceil(_.totalOfEvaluated / itemsPerPage);
      console.log(_.totalPages, 'totalPages');
      if(_.totalPages <= 1){
        _.pagination = false;
      }
      if(pageOffset == 0){
        _.itemsOfFrom = 1;
        _.itemsOfTo = _.candidateList.length;
        _.previousPositionDisabled = true;
      }
      if(pageOffset != 0){
        _.previousPositionDisabled = false;
      }
      if (pageOffset == _.totalPages - 1){
        _.itemsOfTo = _.totalOfEvaluated;
      }
      setTimeout(() => {
        _.isLoading = false;
      }, 2000)
    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
      }
      setTimeout(() => {
        _.isLoading = false;
      }, 2000)
    })
  }

  active_user(reactivate){
    const _ = this;
    _.isLoading = true;
    _.candidateService.active_user(_.userToActivar, reactivate).then((data: any) => {
      _.getInactive();
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 2000)
    })
  }

  nextPageAction(){
    const _ = this;
    _.itemsOfTo = (_.itemsOfTo + _.candidateList.length);
    console.log(_.itemsOfTo, 'incremento 1')
    _.itemsOfFrom = (_.itemsOfFrom + _.candidateList.length);
    console.log(_.itemsOfFrom, 'incremento 2')

    _.pageOffset++;
    _.currentPage++;
    _.nextPage++;
    _.getInactive(_.pageOffset);

    if(_.totalPages == _.currentPage){
      _.nextPositionDisabled = true;
      console.log(_.nextPositionDisabled, '98898')
      return
    }
  }

  previousPageAction(){
    const _ = this;
    if(_.currentPage == 1){
      return
    }
    _.itemsOfTo = _.itemsOfTo - _.candidateList.length;
    _.itemsOfFrom = _.itemsOfFrom - _.candidateList.length;
    _.pageOffset--;
    _.currentPage--;
    _.nextPage--;
    _.getInactive(_.pageOffset);

    if(_.totalPages != _.currentPage){
      _.nextPositionDisabled = false;
      console.log(_.nextPositionDisabled, 'false')
      return
    }
  }
}
